if (!customElements.get('hexaled-before-after')) {
  class HexaledBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.hexaled-ba__range');
      this.afterImg = this.querySelector('.hexaled-ba__img--after');
      this.handle = this.querySelector('.hexaled-ba__handle');
      if (!this.range) return;
      this.update(this.range.value);
      this.range.addEventListener('input', (e) => this.update(e.target.value));
    }
    update(value) {
      this.afterImg.style.clipPath = `inset(0 0 0 ${value}%)`;
      this.handle.style.left = `${value}%`;
    }
  }
  customElements.define('hexaled-before-after', HexaledBeforeAfter);
}
